import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { requestLastLoginDetails } from '../../actions/LastLoginActionCreator';
import LastLoginStore from '../../stores/LastLoginStore';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { LoadingSpinner } from '../LoadingSpinner';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { ICON_DICT_LARGE } from '../../constants/LastLoginConstants';
import StepHeader from '../../includes/StepHeader';
import Helmet from 'react-helmet';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StringConstants from '../../constants/StringConstants';

export class LastLoginPage extends Component {
  constructor(props) {
    super(props);

    // Always keep the data as fresh as possible
    this.state = {
      data: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    LastLoginStore.addChangeListener(this.onLastLoginStoreChange);
    requestLastLoginDetails();
  }

  componentWillUnmount() {
    LastLoginStore.removeChangeListener(this.onLastLoginStoreChange);
  }

  onLastLoginStoreChange = () => {
    this.setState({
      data: LastLoginStore.getDetails(),
      isLoading: false,
    });
  };

  handleBackButton() {
    InternetBankingActions.navigateToWebTask(StringConstants.WEB_HOMEPAGE);
  }

  render() {
    const { content } = this.props;

    const { data, isLoading } = this.state;
    if (isLoading) {
      return <LoadingSpinner />;
    }

    const { platformDetails, platformType, loginDate } = data ?? {};

    return (
      <div className="page bow last-login-page">
        <Helmet title="Last Login Page" />
        <div id="site-main" className="container" role="main" tabIndex="-1">
          <div className="row">
            <div className="col-md1-18">
              {
                <StepHeader
                  showheaderCrumbs
                  headerCrumbsMessage={content.back}
                  onClick={this.handleBackButton}
                />
              }
            </div>
          </div>
          <div className="last-login-page__info-wrapper">
            <div>
              <div className="last-login-page__page-heading">
                <SubHeading>Previous login</SubHeading>
              </div>
              <div className="last-login-page__icon-container">
                <Icon iconType={ICON_DICT_LARGE[platformType]} iconSize="sm" />
                <div className="last-login-page__icon-container__body-text">
                  <StandardBody data-test-id="platform-details" isFlush>
                    <span>{platformDetails}</span>
                  </StandardBody>
                  {loginDate && (
                    <StandardBody data-test-id="date" isFlush>
                      <span>{loginDate}</span>
                    </StandardBody>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LastLoginPage.propTypes = {
  content: PropTypes.object.isRequired,
};
